import React from 'react'

import { Link } from 'react-router-dom'
import { Tag } from 'antd'
import { LAYOUT_MANAGER_CLIENT_SHOW } from '../../navigation'
import { basicDeleteActionField } from '../../../../components/table/fields/common'
import { configureField } from '../../../../core/utils/list'

export const basicColumns = (props) => {
  const { toggle, remove, loading, filters, resize, hidden, actionLoading } = props

  if (loading) {
    return []
  }

  return [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      fixed: 'left',
      // eslint-disable-next-line react/display-name
      render: (name, record) => <Link to={LAYOUT_MANAGER_CLIENT_SHOW(record.id)}>{name}</Link>,
      ...configureField('c.name', filters, resize, hidden, true, false, false, 200)
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      ellipsis: true,
      ...configureField('c.type', filters, resize, hidden, true, false, true, 200)
    },
    {
      title: 'EMail',
      dataIndex: 'email',
      key: 'email',
      ellipsis: true,
      ...configureField('c.email', filters, resize, hidden, true, false, true, 200)
    },
    {
      title: 'Skype',
      dataIndex: 'skype',
      key: 'skype',
      ellipsis: true,
      ...configureField('c.skype', filters, resize, hidden, true, false, true, 200)
    },
    {
      title: 'Country',
      dataIndex: 'country',
      key: 'country',
      render: (country) => {
        if (country) {
          return <>{country?.name}</>
        }
      },
      ...configureField('country', filters, resize, hidden, false, false, true, 200)
    },
    {
      title: 'Status',
      dataIndex: 'active',
      key: 'active',
      // eslint-disable-next-line react/display-name
      render: (check) => (
        <>{check ? <Tag color='green'> ENABLED </Tag> : <Tag color='volcano'> DISABLED </Tag>}</>
      ),
      ...configureField('c.active', filters, resize, hidden, true, false, true, 200)
    },
    {
      ...basicDeleteActionField({ toggle, remove, loading: actionLoading }),
      visible: true
    }
  ]
}
